var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("textarea", {
    directives: [
      {
        name: "model",
        rawName: "v-model.lazy",
        value: _vm.valueModel,
        expression: "valueModel",
        modifiers: { lazy: true },
      },
    ],
    ref: "inputRef",
    attrs: {
      id: _vm.id,
      name: _vm.id || _vm.name,
      placeholder: _vm.placeholder,
      disabled: _vm.disabled,
      readonly: _vm.readonly,
      "data-lpignore": _vm.browserAutocomplete ? null : true,
      autocomplete: _vm.browserAutocomplete ? null : "off",
    },
    domProps: { value: _vm.valueModel },
    on: {
      focus: _vm.handleBaseFocus,
      blur: _vm.handleBaseBlur,
      change: [
        function ($event) {
          _vm.valueModel = $event.target.value
        },
        _vm.handleBaseChange,
      ],
      input: _vm.handleInput,
      keypress: function ($event) {
        if (
          !$event.type.indexOf("key") &&
          _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
        ) {
          return null
        }
        return _vm.handleKeypressEnter.apply(null, arguments)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }